import AbstractScheduler from './AbstractScheduler';
import Token from './Token';
import { PlayerEvent } from '../../PlayerEvents';
import { PropertyPriority } from '../../core/Constant';
import log from 'loglevel';

/**
 * 直播调度策略
 *
 * @export
 * @class LiveScheduler
 * @extends {AbstractScheduler}
 */
export default class LiveScheduler extends AbstractScheduler {
  constructor() {
    super();
    this.currentSubtitleName = 'original';
    this.appliedLiveSubtitle = []; //最终选择使用的字幕内容
    this.appliedType = null; //最终选择使用的类型，1/2/3
    this.mutilSubtitleMap = {};
    this.changeKerneldata = null; //切换内核，重新解析调度数据
    this.changeKernel = false; // 无切换内核 false；切换内核 true
  }
  /**
   * 
   * @param {*} data 
   * @returns 
   * {
      "stream_id": "lss_4b2365d4",
      "live_subtitle": [
          "subtitle"
      ],
      "multi_lang_subtitle": [
          "subtitle_en",
          "subtitle_ru"
      ],
      "quality": [
          "480p",
          "a",
          "same"
      ],
      "rtmp_urls": [
          {
              "url": "rtmp://t-alrtmplive01.e.vhall.com",
              "cdn_name": "ali",
              "app": "vhallyun"
          },
          {
              "url": "rtmp://t-tertmplive01.e.vhall.com",
              "cdn_name": "tx",
              "app": "vhallyun"
          }
      ],
      "hls_urls": [
          {
              "url": "https://t-alhlslivepc01.e.vhall.com",
              "cdn_name": "ali",
              "app": "vhallyun",
              "m3u8": "livestream.m3u8"
          },
          {
              "url": "https://t-tehlslivepc01.e.vhall.com",
              "cdn_name": "tx",
              "app": "vhallyun",
              "m3u8": "livestream.m3u8"
          }
      ],
      "httpflv_urls": [
          {
              "url": "https://t-alflvlive01.e.vhall.com",
              "cdn_name": "ali",
              "app": "vhallyun"
          },
          {
              "url": "https://t-teflvlivepc01.e.vhall.com",
              "cdn_name": "tx",
              "app": "vhallyun"
          }
      ],
      "rtl_urls": [
          {
              "url": "webrtc://t-teflvlivepc01.e.vhall.com",
              "cdn_name": "tx",
              "app": "vhallyun"
          }
      ],
      "timeshift": {
          "hls_urls": [
              {
                  "url": "https://t-tehlsliveshift01.vhallyun.com",
                  "cdn_name": "tx",
                  "m3u8": "timeshift.m3u8",
                  "app": "timeshift/vhallyun"
              }
          ]
      }
    }
   */
  resolveData(data) {
    if (+data.code !== 200) {
      this.player.emit2All(PlayerEvent.SCHEDULER_FAIL, { code: 1, message: '获取直播状态码不为200' });
      log.error(`获取直播状态码不为200，状态码为:${data.code}`);
      return;
    }
    this.player.emit2All(PlayerEvent.SCHEDULER_SUCCESS, { code: 0, message: 'success' });
    this.player.on(PlayerEvent.CHANGEKERNELDATA, this.kernelData.bind(this));
    
    this.liveSubtitleEnable = this.option["live_subtitle_enable"];
    this.liveSubtitleAuto = this.option["live_subtitle_auto"];

    if(this.liveSubtitleEnable) {
      let liveSubtitleMPS = []; // 腾讯云MPS实时字幕
      let livesubtitleDEV = []; //自研实时字幕
      let vod2liveMultilang = []; //点播转直播多语言字幕
      // 获取腾讯云MPS实时字幕配置
      // this.option["live_subtitle_mps"] = "chs2chs"; //临时样例
      if (this.option["live_subtitle_mps"]) {
        let live_subtitle_mps_str = this.option["live_subtitle_mps"].trim();
        let live_subtitle_mps_arr = live_subtitle_mps_str.split(',');
        let live_subtitle_mps_arr_trim = [];
        live_subtitle_mps_arr.forEach((s) => { 
          live_subtitle_mps_arr_trim.push(s.trim());
        });
        let live_subtitle_mps_arr_filter = live_subtitle_mps_arr_trim.filter(function (s) { return s && s.trim(); });
        liveSubtitleMPS = live_subtitle_mps_arr_filter;
      }
      // 获取自研实时字幕配置
      livesubtitleDEV = data['data']['dispatch_urls_v2']['live_subtitle'];
      // 获取多语言字幕伪直播配置
      vod2liveMultilang = data['data']['dispatch_urls_v2']['multi_lang_subtitle']; // []
  
      // 决策优先级：腾讯云MPS实时字幕 > 多语言伪直播字幕 > 自研实时字幕
      if (liveSubtitleMPS.length > 0) {
        this.appliedLiveSubtitle = liveSubtitleMPS;
        this.appliedType = 3;
      } else if (vod2liveMultilang.length > 0) {
        this.appliedLiveSubtitle = vod2liveMultilang;
        this.appliedType = 2;
      } else if (livesubtitleDEV.length > 0) {
        this.appliedLiveSubtitle = livesubtitleDEV;
        this.appliedType = 1;
      } else {
        // 无任何字幕
      }
    }
    
    this.changeKerneldata = data;
    this.transformdata(data);
  }

  kernelData(changeType) {
    this.type = changeType;
    this.changeKernel = true;
    this.transformdata(this.changeKerneldata);
  }

  transformdata(data) {
    var obj = data['data']['dispatch_urls_v2'];
    var stream = obj.stream_id;
    var quality = obj.quality;
    var hls_urls = obj.hls_urls;
    var httpflv_urls = obj.httpflv_urls;
    var rtmp_urls = obj.rtmp_urls;
    var rtl_urls = obj.rtl_urls;
    var timeshifthls_urls = obj.timeshift ? obj.timeshift.hls_urls : [];
    var localDispatchMap = {};
    localDispatchMap["original"] = {};
    if (this.appliedLiveSubtitle.length > 0) {
      for (var m = 0; m < this.appliedLiveSubtitle.length; m++) {
        var lang = this.appliedLiveSubtitle[m];
        localDispatchMap[lang] = {};
      }
    }

    for (var i = 0; i < quality.length; i++) {
      var q1 = quality[i];
      var q = '_' + q1;
      if (q === '_same') {
        q = '';
      }
      Object.keys(localDispatchMap).forEach(lang => {
        if (!(lang != "original" && q1 === 'a')) {
          localDispatchMap[lang][q1] = []; 
        }
      })

      if (this.type === "rtl") {
        for (var j = 0; j < rtl_urls.length; j++) {
          var cdn = rtl_urls[j];
          var url = cdn.url;
          var app = cdn.app;
          var cdnname = cdn.cdn_name;
          Object.keys(localDispatchMap).forEach(lang => {
            var videoUrl;
            if (lang === "original") {
              videoUrl = url + '/' + app + '/' + stream + q;
            } else {
              videoUrl = url + '/' + app + '/' + stream + '_' + lang + q;
            }
            if (!(lang != "original" && (q1 === 'a' || (this.appliedType == 3 && cdnname != 'tx')))){
              localDispatchMap[lang][q1].push({
                cdn_name: cdnname,
                url: videoUrl,
                line: '线路' + (j + 1)
              });
            }
          })
        }
      } else if (this.type === "hls") {
        var hls_urls_settled = this.option.live_type === 1 && this.player.player._type !== 'FlashPlayer' && 
            timeshifthls_urls ? 
            timeshifthls_urls : hls_urls;
        for (var j = 0; j < hls_urls_settled.length; j++) {
          var cdn = hls_urls_settled[j];
          var url = cdn.url;
          var app = cdn.app;
          var cdnname = cdn.cdn_name;
          var m3u8 = cdn.m3u8;
          Object.keys(localDispatchMap).forEach(lang => {
            var videoUrl;
            if (lang === "original") {
              videoUrl = url + '/' + app + '/' + stream + q + '/' + m3u8;
            } else {
              videoUrl = url + '/' + app + '/' + stream + '_' + lang + q + '/' + m3u8;
            }
            if (!(lang != "original" && (q1 === 'a' || (this.appliedType == 3 && cdnname != 'tx')))){
              localDispatchMap[lang][q1].push({
                cdn_name: cdnname,
                url: videoUrl,
                line: '线路' + (j + 1)
              });
            }
          })
        }
      } else if (this.type === "flv") {
        for (var j = 0; j < httpflv_urls.length; j++) {
          var cdn = httpflv_urls[j];
          var url = cdn.url;
          var app = cdn.app;
          var cdnname = cdn.cdn_name;
          Object.keys(localDispatchMap).forEach(lang => {
            var videoUrl;
            if (lang === "original") {
              videoUrl = url + '/' + app + '/' + stream + q + '.flv';
            } else {
              videoUrl = url + '/' + app + '/' + stream + '_' + lang + q + '.flv';
            }
            if (!(lang != "original" && (q1 === 'a' || (this.appliedType == 3 && cdnname != 'tx')))){
              localDispatchMap[lang][q1].push({
                cdn_name: cdnname,
                url: videoUrl,
                line: '线路' + (j + 1)
              });
            }
          })
        }
      } else if (this.type === "rtmp") {
        for (var j = 0; j < rtmp_urls.length; j++) {
          var cdn = rtmp_urls[j];
          var url = cdn.url;
          var app = cdn.app;
          var cdnname = cdn.cdn_name;
          Object.keys(localDispatchMap).forEach(lang => {
            var videoUrl;
            if (lang === "original") {
              videoUrl = url + '/' + app + '/' + stream + q;
            } else {
              videoUrl = url + '/' + app + '/' + stream + '_' + lang + q;
            }
            if (!(lang != "original" && (q1 === 'a' || (this.appliedType == 3 && cdnname != 'tx')))){
              localDispatchMap[lang][q1].push({
                cdn_name: cdnname,
                url: videoUrl,
                line: '线路' + (j + 1)
              });
            }
          })
        }
      }
    }

    this.mutilSubtitleMap = localDispatchMap;
    this.resolveDataMultilang(data['data']['token']);
  }

  /**
   * this.mutilSubtitleMap内容示例如下：
   {
      "original": {
          "480p": [
              {
                  "cdn_name": "ali",
                  "url": "https://t-alflvlive01.e.vhall.com/vhallyun/lss_4b2365d4_480p.flv",
                  "line": "线路1"
              },
              {
                  "cdn_name": "tx",
                  "url": "https://t-teflvlivepc01.e.vhall.com/vhallyun/lss_4b2365d4_480p.flv",
                  "line": "线路2"
              }
          ],
          "a": [
              {},
              {}
          ],
          "same": [
              {},
              {}
          ]
      },
      "subtitle": {
          "480p": [
              {},
              {}
          ],
          "same": [
              {},
              {}
          ]
      }
    }
   */
  resolveDataMultilang(tokenStr) {
    // 创建token
    let token = new Token();
    token.player = this.player;
    token.create(tokenStr);
    
    // 整理带字幕和不带字幕的线路
    let allUrlsMap = this.mutilSubtitleMap;
    let newLinesMap = {};
    for (let keyOf in allUrlsMap) {
      let curObj = allUrlsMap[keyOf];
      let defList = Object.keys(curObj);
      let lineCount = curObj[defList[0]].length;
      let defs = [];
      while (lineCount) {
        defs.push([]);
        lineCount -= 1;
      }

      Object.keys(curObj).forEach(def => {
        Object.values(curObj[def]).forEach((item, index) => {
          if (this.option['quality'].length && this.option['quality'].indexOf(def) === -1) {
            return;
          }
          let subDef = {
            idx: index,
            line: item['line'],
            is_subtitle: keyOf !== 'original',
            url: item["url"],
            def: def,
            cdnName: item['cdn_name']
          };

          defs[index].push(subDef);
          defs[index].sort((a, b) => PropertyPriority[a.def] - PropertyPriority[b.def]);
        });
      });

      log.info(
        `整理${keyOf === 'original' ? '不带' : '带'}字幕直播清晰度完成,共有${defs.length}条线路，每条线路有${
          defs.length > 0 ? defs[0].length : 0
        }个清晰度`
      );

      newLinesMap[keyOf] = defs;
      this.mutilSubtitleMap[keyOf] = defs;
    }

    this._defineDefPropertyMultilang(newLinesMap);
  }

  /**
   * this.mutilSubtitleMap内容示例如下：
    {
      "original": [
          [
              {
                  "idx": 0,
                  "line": "线路1",
                  "is_subtitle": false,
                  "url": "https://t-teflvlivepc01.e.vhall.com/vhallyun/lss_4b2365d4.flv",
                  "def": "same",
                  "cdnName": "tx"
              },
              {
                  "idx": 0,
                  "line": "线路1",
                  "is_subtitle": false,
                  "url": "https://t-teflvlivepc01.e.vhall.com/vhallyun/lss_4b2365d4_480p.flv",
                  "def": "480p",
                  "cdnName": "tx"
              },
              {
                  "idx": 0,
                  "line": "线路1",
                  "is_subtitle": false,
                  "url": "https://t-teflvlivepc01.e.vhall.com/vhallyun/lss_4b2365d4_a.flv",
                  "def": "a",
                  "cdnName": "tx"
              }
          ],
          [ //线路2, ali
              {},
              {},
              {}
          ]
      ],
      "subtitle": [
          [
              {},
              {}
          ],
          [
              {},
              {}
          ]
      ]
    }
   */
  _defineDefPropertyMultilang(defListObj) {
    let allDefinitionListObj = defListObj;
    // 所有带字幕清晰度列表
    let allSubtitleDefList;
    if (this.appliedLiveSubtitle.length > 0 && this.liveSubtitleAuto) {
      allSubtitleDefList = defListObj[this.appliedLiveSubtitle[0]];
      this.player.player._isOpenedLiveSubtitle = true;
      this.currentSubtitleName = this.appliedLiveSubtitle[0];
    } else {
      allSubtitleDefList = defListObj['original'];
      this.player.player._isOpenedLiveSubtitle = false;
      this.currentSubtitleName = 'original';
    }

    // 默认选中列表中第一个CDN线路
    let currentCDNIndex = 0;
    // 当前带字幕清晰度列表
    let currentSubtitleDefList = allSubtitleDefList[currentCDNIndex] || [];
    // 决策将要播放的具体地址
    let currentDefinition;
    if (currentSubtitleDefList.length == 0) {
      log.error("调度无法获取匹配协议的播放地址！")
      return;
    } else if (currentSubtitleDefList.length === 1) {
      currentDefinition = currentSubtitleDefList[0];
    } else {
      let defaultDef = this.option['defaultDef'];
      let defaultDefList = currentSubtitleDefList.filter(item => {
        return item.def === defaultDef;
      });
      if(defaultDefList.length > 0) {
        // 如有匹配清晰度，则使用
        currentDefinition = defaultDefList[0];
      } else {
        // 如无匹配清晰度，则优先寻找其他“非原画非音频”
        let alternatives = currentSubtitleDefList.filter(item => {
          return item.def !== 'same' && item.def !== 'a';
        });
        if (alternatives.length > 0) {
          currentDefinition = alternatives[0];
        } else {
          currentDefinition = currentSubtitleDefList[0];
        }
      }
    }

    // 为videoModule实例增加属性和赋值
    let properties = {
      currentSubtitleName: this.currentSubtitleName,
      currentDefinitionListIndex: currentCDNIndex,
      currentDefinitionList: currentSubtitleDefList,
      allDefinitionList: allDefinitionListObj,
      mutilSubtitleMap: this.mutilSubtitleMap,
    };
    for (const key in properties) {
      Object.defineProperty(this.player, key, {
        configurable: true,
        get: function () {
          return properties[key];
        },
        set: function (newValue) {
          properties[key] = newValue;
        }
      });
    }

    // 重要！ 监听此事件用于切换播放地址
    // todo： 优化代码位置
    Object.defineProperty(this.player, 'currentDefinition', {
      configurable: true,
      get: function () {
        return currentDefinition;
      },
      set: function (newValue) {
        log.info('切换线路');
        log.info(`old: ${JSON.stringify(currentDefinition)}`);
        log.info(`new: ${JSON.stringify(newValue)}`);
        const e = {
          oldValue: currentDefinition,
          newValue
        };
        let { url: oldURL } = currentDefinition;
        let { url: newURL } = newValue;
        if (oldURL === newURL) {
          log.info('新旧线路相同');
          // 某些情况下（拉流失败等），卡顿通过切换清晰度逻辑进行容错。故清晰度相同也切
          // return;
        }
        currentDefinition = newValue;
        if (newValue.noSet) {
          delete newValue.noSet;
          return;
        }
        let token = this.newToken;
        let url = `${newValue.url}?token=${token}`;
        // 时移直播
        if (
          this._config.isLive &&
          this._config.isOpenTimeshift &&
          this._config.type === 'hls' &&
          this.player.getCdnName() === 'tx'
        ) {
          url = `${newValue.url}?delay=${this.player.delay}&token=${token}`;
        }

        this.player.setSrc(url);
        this.player.emit2All(PlayerEvent.DEFINITION_CHANGED, e);
        log.info('切换完成');
      }
    });

    // 带字幕直播默认开启
    if (this.player.player._isOpenedLiveSubtitle) {
      this.player.emit2All(PlayerEvent.LIVESUBTITLE_OPENED);
    }

    // 直播播放调度完成。VideoModule监听此事件后执行setSrc()。
    this.player.emit2All(PlayerEvent.SCHEDULER_COMPLETE);
    if (!this.changeKernel) {
      //无切换内核降级
      if (!this.readySeted) {
        this.player.emit2All(PlayerEvent.READY);
        this.readySeted = true;
      } else {
        this.player.emit2All(PlayerEvent.REFRESH_DISPATCH_COMPLETED);
      }
    } else {
      //切换内核降级，
      this.player.emit2All(PlayerEvent.CHANGE_SCHEDULER_DATA);
    }
  }
}
